import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["addButton"];
  static values = { count: Number, max: Number };

  connect() {
    this.toggleButton();
  }

  countValueChanged() {
    this.toggleButton();
  }

  toggleButton() {
    const isLimitReached = this.countValue >= this.maxValue;
    this.addButtonTargets.forEach((btn) => {
      btn.disabled = isLimitReached;
    });
  }
}
